// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from '../src/store/index'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
//import { JSEncrypt } from 'jsencrypt'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/scss/default.scss'
import Utils from './utils/utils.js'
import { productFruits } from 'product-fruits';



window.Utils = Utils;
Vue.prototype.$box = Utils
/*Vue.prototype.$getCode = function (psd) {
  let encrypt = new JSEncrypt()
  encrypt.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCzle2EdTQK72M+HC2nCvUbhjdNWTQTZ0VHYNYqlj6CjLE1+93MN4I1SkwB+4CHJp7eDQ0dB7s5OeFtD7K0Xi7c1AleYMqxnVJRmQhryyIIZCaB5nywKuPKC0sDI/zab4OThq0nSOfeUQOkY9JmIomy20bgRmRNxlIWFTVPLg6+DQIDAQAB')
  let data = encrypt.encrypt(psd)
  return data
}*/

// Init product fruit
const venueName = sessionStorage.getItem("subVenueName")

if (venueName && venueName != 'undefined') {
  productFruits.init('zvNdUTfqmAbIOz1V', 'en', { username: venueName });
  productFruits.init('kTj3ThRu5JTrSF4g', 'en', { username: venueName });
}

// STYLING COLOR DYNAMIC
const root = document.documentElement;
root.style.setProperty('--background-color', process.env.BACKGROUND_COLOR ? process.env.BACKGROUND_COLOR : ' #212429');
root.style.setProperty('--background-color-2', process.env.BACKGROUND_COLOR_2 ? process.env.BACKGROUND_COLOR_2 : '#1a1919');
root.style.setProperty('--background-color-3', process.env.BACKGROUND_COLOR_3 ? process.env.BACKGROUND_COLOR_3 : '#151C27');
root.style.setProperty('--background-color-4', process.env.BACKGROUND_COLOR_4 ? process.env.BACKGROUND_COLOR_4 : '#2b3444');
root.style.setProperty('--primary-color', process.env.PRIMARY_COLOR ? process.env.PRIMARY_COLOR : '#ea3796');
root.style.setProperty('--secondary-color', process.env.SECONDARY_COLOR ? process.env.SECONDARY_COLOR : '#fff');
root.style.setProperty('--text-color', process.env.TEXT_COLOR ? process.env.TEXT_COLOR : '#fff');

router.beforeEach((to, from, next) => {
  let token = window.sessionStorage.getItem('token');

  let path = to.path;

  const publicUrls = ['/login'];
  // if (token) {
  //   if (publicUrls.includes(path)) {
  //     next({path: '/dashboard'})
  //     return;
  //   }
  // }

  if (path == '/login' || path == '/forget' || path == '/video' || path == '/register' || path == '/welcome'
   || path == '/time' || path == '/rent' || path == '/pay'||path == '/wel-come' || path == '/download' || '/privacy-policy') {
      next();
      return;
  }      //以防无限循环

  if (token) {
    next();
  } else {
      next({
          path: '/login'
      })
  }
})

Vue.config.productionTip = false
Vue.use(ElementUI, { locale })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js